import {
    LEADING_SUMMARY_AMENDS_KEY,
    isLeadingSummaryTaskId,
} from "authoring/routes/project/amends/lib/constants/amends-keys"

export function getReviewDecisionAmendsKey(amend, scheduleId) {
    const taskTitle = amend?.payload?.taskTitle
    if (taskTitle === "intro.content" || taskTitle === "intro.note") return taskTitle
    if (taskTitle === "details:code") return "code"
    if (taskTitle === "details:unitOfMeasure") return "unitOfMeasure"
    if (taskTitle === "details") return "title"
    if (taskTitle === LEADING_SUMMARY_AMENDS_KEY) return LEADING_SUMMARY_AMENDS_KEY

    const taskId = amend?.payload?.taskId
    if (!taskId) return null
    if (taskId === `${scheduleId}-details`) return "title"
    if (taskId === `${scheduleId}-details:code`) return "code"
    if (taskId === `${scheduleId}-details:unitOfMeasure`) return "unitOfMeasure"
    if (taskId === `${scheduleId}-intro.content`) return "intro.content"
    if (taskId === `${scheduleId}-intro.note`) return "intro.note"
    if (taskId === `${scheduleId}-movements`) return "movements"
    if (isLeadingSummaryTaskId(taskId, scheduleId)) return LEADING_SUMMARY_AMENDS_KEY
    if (taskId.startsWith(`${scheduleId}-`)) return null
    return `tasks.${taskId}`
}
